import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementTimeGetTimeRequest,
	ManagementTimeGetTimeResult,
	ManagementTimeRequests,
	ManagementTimeSetManualRequest,
	ManagementTimeSetManualResult,
	ManagementTimeSetNTPRequest,
	ManagementTimeSetNTPResult,
} from './timeCommands';

export function handleManagementTimeCommands(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementTimeRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementTimeRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementTimeGetTimeRequest:
				await dispatch<ManagementTimeGetTimeResult>({
					type: ManagementTimeGetTimeResult,
					result: await frontApplet.management.time.get(),
				});
				break;
			case ManagementTimeSetManualRequest:
				await dispatch<ManagementTimeSetManualResult>({
					type: ManagementTimeSetManualResult,
					result: {},
				});
				await frontApplet.management.time.setManual(commandEvent.command.dateTime, commandEvent.command.timezone);
				break;
			case ManagementTimeSetNTPRequest:
				await dispatch<ManagementTimeSetNTPResult>({
					type: ManagementTimeSetNTPResult,
					result: {},
				});
				await frontApplet.management.time.setNTP(commandEvent.command.ntpServer, commandEvent.command.timezone);
				break;
			default:
		}
	});
}
